import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Avatar, CardContent, CardHeader, Checkbox, Typography } from "@mui/material";
import { useState } from "react";



function GroupDisplay(props) {
    const {group, handleEdit, handleDelete, handleSave} = props

    const[gname, setGName] = useState(group.groupName);
     
    return (
    <>
        <Box display={'flex'} columnGap={3} alignItems={'center'} >
            <Avatar>{gname[0]}</Avatar>
            <Typography>{group.groupName}</Typography>
            <Checkbox sx={{ ml: 'auto' }}></Checkbox>
            <Button onClick={() => { handleEdit(group) }}>Edit</Button>
            <Button onClick={() => { handleDelete(group) }} color="error">Delete</Button>
        </Box>
        <Stack display={group.edit}>
            <Box display={'flex'} justifyContent={'space-evenly'} columnGap={2} mt={2}>
                <TextField
                    label='Group Name'
                    contentEditable
                    value={gname}
                    onChange={(e)=>setGName(e.target.value)}
                />
            </Box>
            <Box display={'flex'} justifyContent={'space-evenly'}>
                <Button sx={{ mt: 2 }} color="success" variant="outlined" size="small" >Save</Button>
            </Box>
        </Stack>
    </>);
}

export default GroupDisplay;